import React from 'react';
import PropTypes from 'prop-types';
import { dateToString } from '../../../common/utils/date/Date.utils';
import { preparePriceFormat } from '../../../common/helpers/preparePriceFormat';

function TransactionTableRow({ item }) {
  return (
    <>
      <td className="cropped-row-cell">{dateToString(item?.createdOn)}</td>
      <td className="cropped-row-cell">{item.title}</td>
      <td>
        <span className="font-weight-bold">
          {preparePriceFormat(item.amountInPence, true)}
        </span>
      </td>
    </>
  );
}

TransactionTableRow.propTypes = {
  item: PropTypes.object.isRequired,
};

export default TransactionTableRow;
